import { SxProps, Theme } from '@mui/material';
import { CrmColors, inkOver } from '../../crm-theme';

const SIZES = {
    small: { box: 26, font: 10, icon: 15 },
    medium: { box: 30, font: 12, icon: 16 },
};

export type OwnerAvatarSize = keyof typeof SIZES;

/// `owner`: cor da pessoa responsável; sem dono, vazio e tracejado lê como falta.
export const ownerAvatarSx = (cc: CrmColors, owner: string | null, size: OwnerAvatarSize, clickable: boolean): SxProps<Theme> => ({
    width: SIZES[size].box,
    height: SIZES[size].box,
    fontSize: SIZES[size].font,
    fontWeight: 700,
    cursor: clickable ? 'pointer' : 'inherit',
    bgcolor: owner ?? 'transparent',
    color: owner ? inkOver(owner) : cc.textSecondary,
    border: owner ? 'none' : `1px dashed ${cc.borderStrong}`,
});

export const addOwnerIconSx = (size: OwnerAvatarSize): SxProps<Theme> => ({ fontSize: SIZES[size].icon });
